import { createFileRoute } from '@tanstack/react-router'
import { RolesPage } from '@portal/app-admin'

export const Route = createFileRoute('/_auth/preferences/roles/')({
  component: RolesPage,
})
